import router from '../router'
import globalTitle from './globalTitle'
import { hasIntersect } from '@common/js/common'

let firstMenus = [
  {
    title: 'DashBoard',
    icon: 'chart3',
    children: false,
    key: globalTitle.DASHBOARD,
    permList: false,
    url: '/snapshot',
  },
  {
    title: 'Advertiser',
    icon: 'oabs-ad-manager',
    children: true,
    key: globalTitle.ADVERTISER,
  },
  {
    title: 'Offer',
    icon: 'layers',
    children: true,
    key: globalTitle.OFFER,
  },
  {
    title: 'Publisher',
    icon: 'list2',
    children: true,
    key: globalTitle.AFFILIATE,
  },
  {
    title: 'Self Service',
    icon: 'earth',
    children: true,
    key: globalTitle.SELF_SERVICE,
  },
  {
    title: 'Interactive Ads',
    icon: 'oabs-ad-manager',
    children: true,
    key: globalTitle.Interactive_Ads,
  },
  {
    title: 'OPPO Reach',
    icon: 'oabs-employ-manager',
    children: true,
    key: globalTitle.OPPO_Reach,
  },
  {
    title: 'SDK',
    icon: 'chart3',
    children: true,
    key: globalTitle.SDK,
  },
  {
    title: 'Finance',
    icon: 'money1',
    children: true,
    key: globalTitle.FINANCE,
  },
  {
    title: 'Traffic Quality',
    icon: 'information',
    children: true,
    key: globalTitle.TRAFFIC_QUALITY,
  },
  {
    title: 'Setup',
    icon: 'tools',
    children: true,
    key: globalTitle.SETTING,
  },
  {
    title: 'Offer Detect',
    icon: 'search',
    children: true,
    key: globalTitle.OFFER_DETECT,
  },
  {
    title: 'Data',
    icon: 'chart2',
    children: true,
    key: globalTitle.REPORT,
  },
  {
    title: 'PUSHGO',
    icon: 'chart1',
    children: true,
    key: globalTitle.PUSHGO,
  },
  {
    title: 'Website Admin',
    icon: 'search',
    children: true,
    key: globalTitle.WEBSITE_MANAGEMENT,
  },
  {
    title: 'Online Earning',
    icon: 'rocket',
    children: true,
    key: globalTitle.ONLINE_EARNING,
  },
  {
    title: 'Q&A',
    icon: 'question',
    children: true,
    key: globalTitle.FEEDBACK,
  },
  {
    title: 'Authorization',
    icon: 'oabs-employ-manager',
    children: true,
    key: globalTitle.PERMISSION,
  },
]

let secondMenus = {}
for (let item of firstMenus) {
  if (item.children) {
    secondMenus[item.key] = [] // 二级菜单初始化
  }
}

function joinPath(parent, child) {
  if (!parent) return child
  if (!child) return parent
  if (child.charAt(0) === '/') return child
  return (parent.replace(/\/$/, '') + '/' + child).replace(/\/+/g, '/')
}

function collectMenuRoutes(routes, parentPath) {
  if (!routes) return
  for (let i = 0; i < routes.length; i++) {
    let route = routes[i]
    let fullPath = joinPath(parentPath, route.path)
    if (route.menu && secondMenus[route.menu]) {
      secondMenus[route.menu].push({
        title: route.meta.title,
        url: fullPath,
        permList: route.meta.permList,
      })
    }
    if (route.children) {
      collectMenuRoutes(route.children, fullPath)
    }
  }
}

collectMenuRoutes(router.options.routes, '')

function insertMenuAfter(menuKey, afterUrl, item) {
  let list = secondMenus[menuKey]
  if (!list || list.some(menu => menu.url === item.url)) return
  let index = list.findIndex(menu => menu.url === afterUrl)
  if (index >= 0) {
    list.splice(index + 1, 0, item)
  } else {
    list.push(item)
  }
}

insertMenuAfter(globalTitle.SELF_SERVICE, '/campaign/list', {
  title: 'Brush Campaign',
  url: '/campaign/brush/list',
  permList: ['self_service.view_campaign_list'],
})

/**
 * 生成菜单对象
 * @permList 用户权限列表 ["ader.view_list","ader.view_detail","ader.edit_detail"...]
 * @isSuperuser 是否管理员
 */
export default function generateMenu(permList, isSuperuser) {
  function hasPerm(perms) {
    return perms === false ? true : hasIntersect(perms, permList)
  }

  function resolveSecondMenus(menus) {
    let arr = []
    menus = secondMenus[menus]
    for (let menu of menus) {
      if (isSuperuser || hasPerm(menu.permList)) {
        arr.push({ text: menu.title, href: menu.url })
      }
    }
    return arr
  }

  function resolveFirstMenus(menus) {
    let arr = []
    for (let menu of menus) {
      if (menu.children) {
        // 一级目录存在子目录
        arr.push({ title: menu.title, icon: menu.icon, items: resolveSecondMenus(menu.key) })
      } else if (isSuperuser || hasPerm(menu.permList)) {
        // 一级目录即为跳转项
        arr.push({ title: menu.title, icon: menu.icon, href: menu.url })
      }
    }
    return arr
  }

  return resolveFirstMenus(firstMenus).filter(m => {
    return m.href || m.items.length
  })
}
